<template>
  <div class="tab-pane fade user-settings" id="tab5" role="tabpanel" aria-labelledby="tab-5">
    <!-- Modal -->
    <update-user-modal :user="selectedUser"/>

    <div class="modal fade" id="deleteUserModal" tabindex="-1" aria-labelledby="deleteUserModal" aria-hidden="true">
      <div class="modal-dialog" style="width: 33%">
        <form v-on:submit.prevent="deleteUser">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">
                Benutzer löschen
              </h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-check">
                    <input id="loeschen" type="checkbox" v-model="deletedchecked" class="form-check-input" placeholder="" required>
                    <label for="loeschen" class="form-check-label">Wirklich löschen?</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <div class="dokubtns text-right">
                <span class="btninner">
                  <button type="button" class="btn btn-red" data-dismiss="modal">Abbrechen</button>
                  <button type="submit" class="btn btn-blue" :disabled="!deletedchecked">
                     Benutzer löschen
                  </button>
                </span>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>

    <div class="modal fade" id="inviteUserModal" tabindex="-1" aria-labelledby="inviteUserModal" aria-hidden="true">
      <div class="modal-dialog" style="width: 33%">
        <form v-on:submit.prevent="inviteUserByEmail">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">
                Benutzer hinzufügen
              </h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="email">Email</label>
                    <input id="email" type="email" v-model="email" class="form-control" placeholder="E-Mail zum Einladen hinzufügen" required>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <div class="dokubtns text-right">
            <span class="btninner">
              <button type="button" class="btn btn-red" data-dismiss="modal">Abbrechen</button>
              <button type="submit" class="btn btn-blue">
                 Einladen
              </button>
            </span>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>


    <div class="form-row">
      <div class="col-md-3 settings_user">
        <div class="innerbox h-100 pr-2 pl-2">
          <h2>Benutzer des Kunden</h2>

          <div class="form-group has-search mb-2">
            <i class="fa fa-search form-control-feedback  search-img" style="top: 55px; font-size: 15px"></i>
            <input v-model="search" type="text" class="form-control" v-bind:placeholder="$t('search_user')" style="height: 35px" />
          </div>

          <div class="inrbox form-group pb-2 mb-2">
            <div class="custom-select-list">
              <ul>
                <li
                  v-for="customer in filteredUsers"
                  :key="customer.pduserid"
                  :class="{ selected: selectedCustomers.some(selected => selected.pduserid === customer.pduserid) }"
                  @click="toggleSelection(customer)">
                  {{ customer.lastname }}, {{ customer.firstname }} - ({{ customer.email }})
                </li>
              </ul>
            </div>
<!--            <select class="form-control"  v-model="selectedCustomers" multiple style="height: 60vh">-->
<!--              <option v-for="customer in filteredUsers"-->
<!--                v-bind:key="customer.pduserid"-->
<!--                      :value="customer">-->
<!--                {{customer.lastname}},  {{customer.firstname}} - ({{customer.email}})-->
<!--              </option>-->
<!--            </select>-->

            <div class="buttons mt-2 row">
              <div class="col-md-6">
                <button v-if="selectedCustomers.length" class="settingbuttons" @click="selectedCustomers = []">
                  Alle deselektieren
                </button>
                <button v-else class="settingbuttons" @click="selectedCustomers = JSON.parse(JSON.stringify(customerUsers))">
                  Alle selektieren
                </button>
              </div>
              <div class="col-md-6 p-0 text-center" >
                <button class="settingbuttons" :disabled="selectedCustomers.length === 0" @click="inviteUser"> Benutzer hinzufügen </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-9">
        <div class="innerbox settings_user">
          <h2>Benutzerliste</h2>
          <div class="inrbox pb-2 pb-md-0">
            <div class="table-settings">
              <table class="table table-sm users-table table-font table-bordered table-hover">
                <thead>
                <tr>
                  <th scope="col">Vorname</th>
                  <th scope="col">Nachname</th>
                  <th scope="col">Firma</th>
                  <th scope="col">E-Mail</th>
                  <th scope="col">Status</th>
                  <th scope="col">Rechte</th>
                  <th scope="col"></th>
                </tr>
                </thead>
                <tbody>

                <tr v-for="user in projectUsers" :class="{active_tr : user.pduserid === selectedUser.pduserid}" :key="user.pduserid" @click="selectedUser = user" v-if="user.active>0">

                  <td>
                    {{ user.firstname }}
                  </td>
                  <td>{{ user.lastname }}</td>
                  <td>{{ user.company }}</td>
                  <td>{{ user.email }}</td>
                  <td>
                    <div class="switch new d-inline pr-1">
                      <label>
                        <input type="checkbox" :true-value="1" :false-value="2" v-model="user.active" @change="changeUserActiveStatus(user)">
                        <span class="lever mr-0 mt-0"></span>
                      </label>
                    </div>
                    <span v-if="user.active === 0">
                    <span class="status green bg-danger"></span> Bestätigt
                  </span>
                    <span v-else-if="user.active === 1">
                    <span class="status green"></span> Aktiviert
                  </span>
                    <span v-else-if="user.active === 2">
                    <span class="status green bg-dark"></span> Deaktiviert
                  </span>
                  </td>
                  <td>
                    <template v-if="usercan('admin')">
                      <select class="form-control form-control-sm" @change="setUserRights(user)" v-model="user.rights">
                        <option value="1">Administrator</option>
                        <option value="2">Benutzer</option>
                        <option value="3">Gast</option>
                      </select>
                    </template>
                    <template v-if="!usercan('admin')">
                      <span v-if="parseInt(user.rights) === 1"> Administrator </span>
                      <span v-else-if="parseInt(user.rights) === 2"> User </span>
                      <span v-else-if="parseInt(user.rights) === 3"> Guest </span>
                    </template>
                  </td>
                  <td>
                    <div class="udarrow float-right" v-if="usercan('admin')" v-visible="user.pduserid === selectedUser.pduserid">
                      <a data-toggle="modal" data-target="#deleteUserModal" class="pr-0 text-dark">
                        <i class="fa fa-trash" aria-hidden="true" style="margin-top: -1px;"></i>
                      </a>
                    </div>
                    <div class="udarrow float-right ml-1" v-if="usercan('admin')" v-visible="user.pduserid === selectedUser.pduserid">
                      <a data-toggle="modal" data-target="#userModal" class="pr-0 text-dark">
                        <i class="fa fa-pencil-square" aria-hidden="true"></i>
                      </a>
                    </div>

                  </td>
                </tr>

                <tr>
                  <td colspan="7">
                    <button data-toggle="modal" data-target="#inviteUserModal" class="settingbuttons">
                      Neuen Benutzer per E-Mail einladen
                    </button>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <div class="dokubtns">
              <div class="btninner float-right">
                <button type="button" class="btn btn-danger mt-2" data-dismiss="modal" @click="$router.push({name: 'photo', params: {id: $route.params.id}})">
                  <strong> Verlassen </strong>
                </button>
              </div>
              <div class="clearfix"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import UpdateUserModal from '../UpdateUserModal'
// import axios from 'axios'
import axios from '../../../utils/axiosinstance'
export default {
  name: 'user',
  components : { UpdateUserModal },
  data(){
    return {
      activeUserId : 0,
      selectedUser: {},
      selectedCustomers: [],
      email: '',
      deletedchecked: false,
      search: ''

    }
  },
  mounted () {

  },
  created () {
    this.$store.dispatch("getProjectUsers",this.$route.params.id);
  },
  computed : {
    projectUsers(){
      return this.$store.state.appSettings.projectUsers
    },
    customerUsers: function (){
      return this.$store.state.appSettings.customerUsers
    },
    sortedUsers() {
      return this.customerUsers.sort((a, b) => a.lastname.localeCompare(b.lastname))
    },
    filteredUsers() {
      // return this.$store.state.appSettings.customerUsers.filter(customer => customer.firstname.toLowerCase().includes(this.$store.state.appSettings.customerUsers.search.toLowerCase()))

      let _this = this;

      if(this.search) {
        return this.sortedUsers.filter(customer => (
            customer.lastname.toLowerCase().includes(_this.search.toLowerCase()) ||
            customer.firstname.toLowerCase().includes(_this.search.toLowerCase()) ||
            customer.email.toLowerCase().includes(_this.search.toLowerCase())
        ));
      }

      return this.customerUsers.sort((a, b) => a.lastname.localeCompare(b.lastname))




    }
  },

  methods: {
    toggleSelection(customer) {
      const index = this.selectedCustomers.findIndex(selected => selected.pduserid === customer.pduserid);
      if (index > -1) {
        this.selectedCustomers.splice(index, 1);
      } else {
        this.selectedCustomers.push(customer);
      }
    },

    // (event) {
    //   console.log('event', event, this.projectUsers, this.selectedUser)
    // },

    async setUserRights(user){
      this.$store.commit("settingsModuleSetLoading",true)
      await axios.post(`${process.env.VUE_APP_BASE_AMF_URL}&token=${localStorage.sessiontoken}`,
        {
          "methodName": "updateUserOfProject",
          "serviceName": "ProjectdocuService",
          "parameters": [ user.pduserid, this.$route.params.id , user ]
        }, {
          headers: {
            apitoken: localStorage.apikey,
            deviceid: localStorage.deviceid,
            accept: 'application/json'
          }
        }).then(res => {
        let msg = res.data === 1 ? "Benutzer aktualisiert" : "Benutzer aktualisiert"
        this.$toast.success(msg)
      });
      this.$store.commit("settingsModuleSetLoading",false)
    },

    async deleteUser () {
      $('#deleteUserModal').modal('toggle')
      let user = this.selectedUser;
      user.active = -1
      let idx = this.$store.state.appSettings.projectUsers.findIndex((item) => item.pduserid == user.pduserid)
      this.sendDeleteUser(user)
      this.$store.state.appSettings.projectUsers.splice(idx, 1)
      this.deletedchecked = false
    },

    async inviteUser(){
      let ids = [];
      let _this = this
      _this.$store.commit('settingsModuleSetLoading',true);
      let projectUsersIds = this.projectUsers.map(item => item.pduserid);
      this.selectedCustomers.forEach(item => {
        if (!projectUsersIds.includes(item.pduserid)){
          return  ids.push(item.pduserid)
        }
      });
      if (ids.length){
        await _this.sendInvitationToUsers(ids);
      }else {
        _this.$toast.error('This user already exist')
      }
      _this.$store.commit('settingsModuleSetLoading',false);
      _this.selectedCustomers = [];
    },

    async inviteUserByEmail(){
      $('#inviteUserModal').modal('toggle');
      await this.sendInvitationToUser(this.email);
    },

    //Send invitation to multiple user by users ids
    async  sendInvitationToUsers(ids){
      let _this = this
      await axios.post(`${process.env.VUE_APP_BASE_AMF_URL}&token=${localStorage.sessiontoken}`,
        {
          "methodName": "inviteUsers",
          "parameters": [ids , this.$route.params.id], //invite by user id or email
          "serviceName": "ProjectdocuService"
        }, {
          headers: {
            apitoken: localStorage.apikey,
            deviceid: localStorage.deviceid,
            accept: 'application/json'
          }
        }).then(res => {
        if (res.status === 200 || res.statusText === "OK"){
          _this.$store.dispatch("getProjectUsers",this.$route.params.id);
          _this.$toast.success("Benutzer hinzugefügt");
          _this.email = '';
        }
      }).catch( error => {
        this.$store.commit("settingsModuleSetLoading",false)
      })
    },

    //Send Invitation to single user by email
    async  sendInvitationToUser(email){
      let _this = this
      await axios.post(`${process.env.VUE_APP_BASE_AMF_URL}&token=${localStorage.sessiontoken}`,
        {
          "methodName": "inviteUser",
          "parameters": [email , this.$route.params.id], //invite by user id or email
          "serviceName": "ProjectdocuService"
        }, {
          headers: {
            apitoken: localStorage.apikey,
            deviceid: localStorage.deviceid,
            accept: 'application/json'
          }
        }).then(res => {
        if (res.status === 200 || res.statusText === "OK"){
          _this.$store.dispatch("getProjectUsers",this.$route.params.id)
          _this.$store.commit('settingsModuleSetLoading',false)
          _this.$toast.success("Benutzer hinzugefügt")
          _this.email = '';
        }
      }).catch( error => {
        this.$store.commit("settingsModuleSetLoading",false)
      })
    },

    async changeUserActiveStatus(user){
      this.$store.commit("settingsModuleSetLoading",true)
      await axios.post(`${process.env.VUE_APP_BASE_AMF_URL}&token=${localStorage.sessiontoken}`,
        {
          "methodName": "setActivation",
          "serviceName": "ProjectdocuService",
          "parameters": [ user.pduserid, this.$route.params.id , user.active ]
        }, {
          headers: {
            apitoken: localStorage.apikey,
            deviceid: localStorage.deviceid,
            accept: 'application/json'
          }
        }).then(res => {
        let msg = res.data === 1 ? "Benutzer aktiviert" : "Benutzer deaktiviert"
        this.$toast.success(msg)
      });
      this.$store.commit("settingsModuleSetLoading",false)
    },

    async sendDeleteUser(user){
      this.$store.commit("settingsModuleSetLoading",true)
      await axios.post(`${process.env.VUE_APP_BASE_AMF_URL}&token=${localStorage.sessiontoken}`,
        {
          "methodName": "setActivation",
          "serviceName": "ProjectdocuService",
          "parameters": [ user.pduserid, this.$route.params.id , user.active ]
        }, {
          headers: {
            apitoken: localStorage.apikey,
            deviceid: localStorage.deviceid,
            accept: 'application/json'
          }
        }).then(res => {
        let msg = res.data === 1 ? "Benutzer gelöscht" : "Benutzer gelöscht"
        this.$toast.success(msg)
      });
      this.$store.commit("settingsModuleSetLoading",false)
    }
  },

  watch: {
    // search: function (val) {
    //   //this.$store.state.appSettings.customerUsers.search = val
    // }
  }
}

</script>

<style scoped>
table.users-table tr{
  cursor: pointer;
}
tr.active_tr{
  background: #3939e640 !important;
}
.udarrow a{
  font-size: 1rem;
  color: black;
}
.udarrow a:hover{
  color: dodgerblue !important;
}
.table-font{
  font-size: 0.85rem;
}
i.fa-pencil-square-o{
  font-size: 1.2rem;
  padding-top: 2px;
}
.btn.btn-primary.btn-sm{
  background: #2c6ed5;
  color: white;
}
.table-settings{
  min-height: calc(100vh - 271px);
}
.custom-select-list{
height: 64vh;
}
.custom-select-list ul {
  max-height: 60vh;
  overflow-y: auto;
  list-style: none;
  margin: 0;
  padding: 0;
  border: 1px solid #ccc;
}

.custom-select-list li {
  padding: 8px;
  cursor: pointer;
  border-bottom: 1px solid #ddd;
  box-shadow: none;
}
.custom-select-list li:last-child {
  border-bottom: 0;
}
.custom-select-list li.selected {
  background-color: #007bff;
  color: white;
}
.custom-select-list li:not(.selected):hover {
  background-color: #f1f1f1;
}
</style>



// WEBPACK FOOTER //
// src/components/appSetting/components/Users.vue